import { login, logout, getInfo, getMenu, getCodeList } from '@/api/user'
import { getToken, setToken, removeToken, setUser } from '@/utils/auth'
import router, {commonroutes, resetRouter} from '@/router'
// import routerP from '@/router/project'
import {menuListToRoutes} from '@/utils/common'
import { Message } from 'element-ui'
import Vue from 'vue'
const getDefaultState = () => {
    return {
        token: getToken(),
        username: '',
        avatar: '',
        uid: '',
        nickName: '',
        email: '',
        gender: 2,
        address: '',
        mobile: '',
        routes: [],
        routesProject: [],
        tabs: {},
        permissions:[],
        roleCode:''
    }
}
const state = getDefaultState
const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState)
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        //state.username = name
        Vue.set(state,'username',name)
    },
    SET_AVATAR: (state, avatar) => {
        //state.avatar = '/static/image/user/1/avatar/259627366223941.png?token=Bearer '
            //'/static'+ avatar
        state.avatar = avatar
    },
    SET_ROUTES: (state, route) => {
        state.routes = route
        // state.routesProject = routeObj.routes1
        // console.log('index路由',state.routes)
        // console.log('project路由',state.routesProject)
        // state.routes = constantRoutes.concat(routes)
    },
    SET_PERMISSIONS: (state, route) => {
        state.permissions = route
    },
    SET_ROUTESP: (state, route) => {
        // state.routes = routeObj.routes
        state.routesProject = route
        // console.log('index路由',state.routes)
        // console.log('project路由',state.routesProject)
        // state.routes = constantRoutes.concat(routes)
    },
    SET_UID: (state, uid) => {
        state.uid = uid
        // console.log(state.uid)
    },
    SET_ELSE: (state, data) => {
        if(data.nickName !==undefined && data.nickName!==''){
            // state.nickName = data.nickName
            Vue.set(state,'nickName',data.nickName)
        }else{
            state.nickName = state.username
            Vue.set(state,'nickName',state.username)
        }
        console.log(state.nickName)
        if(data.email !==undefined && data.email!==''){
            state.email = data.email
        }else{
            state.email = ''
        }
        if(data.gender !==undefined && data.gender!==''){
            state.gender = data.gender
        }else{
            state.gender = 2
        }
        if(data.address !==undefined && data.address!==''){
            state.address = data.address
        }else{
            state.address = ''
        }
        if(data.mobile !==undefined && data.mobile!==''){
            state.mobile = data.mobile
        }else{
            state.mobile = ''
        }
        if(data.roleCode !==undefined && data.roleCode!==''){
            state.roleCode = data.roleCode
        }else{
            state.roleCode = ''
        }
    }
}
const actions = {
    /*async login1(userInfo) {
        const { data: res } = await login(userInfo)
        console.log(res)
    },*/
    login({ commit }, userInfo) {
        // const { username, password } = userInfo
        //console.log(userInfo)
        return new Promise((resolve, reject) => {
            login(userInfo).then(response => {
                if (response.code != 200){
                    Message({
                        message: response.msg,
                        type: 'error',
                        duration: 5 * 1000
                    })
                    reject(response.msg)
                }else{
                    const { data } = response
                    //console.log('用户登录成功',response,userInfo.checked)
                    setToken(data.tokenValue,userInfo.checked)
                    commit('SET_TOKEN', data.tokenValue)
                    resolve()
                }
            }).catch(error => {
                // this.$message.error('error='+error.msg)
                Message({
                    message: error.msg,
                    type: 'error',
                    duration: 5 * 1000
                })
                // console.log(error)
                reject(error)
            })
        })
    },

    // get user info
    getInfo({ commit }) {
        if(sessionStorage.getItem('token')!=undefined&&sessionStorage.getItem('token')!=null){
            commit('SET_TOKEN', getToken())
        }
        return new Promise((resolve, reject) => {
            getInfo().then(response => {
                const { code,data } = response
                if (code!=200) {
                    reject('Verification failed, please Login again.')
                }else{
                    const { userName, avatar, uid } = data
                    // console.log(uid)
                    commit('SET_NAME', userName)
                    commit('SET_AVATAR', avatar)
                    commit('SET_UID', uid)
                    commit('SET_ELSE', data)
                    setUser(JSON.stringify(data))


                    /*var list = []
                    getMenu({tag: 0}).then(responsemenu => {
                        list = responsemenu.data
                        const indexroutes = []
                        const children = []
                        let arr = menuListToRoutes(children,list)
                        indexroutes.push(
                            {
                                path: '/article',
                                component: () => import('@/views/app/Article'),
                                hidden: true
                            },{
                                path: '/pdf',
                                component: () => import('@/views/app/Pdf'),
                                hidden: true
                            },{
                                path: '/index',
                                component: () => import('@/views/index/layout/Index'),
                                // redirect: arr[0].path,
                                children: arr
                            },{
                                path: '/dashboard',
                                component: () => import('@/views/index/datav/Index'),
                                hidden: true
                            },{
                                path: '/up',
                                name: 'SYS-USER-PROJECT',
                                component: () => import('@/views/index/up/Index'),
                                meta: {
                                    title: '用户项目'
                                },
                                hidden: true
                            }
                        )
                        for(let i=0;i<indexroutes.length;i++){
                            router.addRoute(indexroutes[i])
                        }
                        for(let i=0;i<commonroutes.length;i++){
                            router.addRoute(commonroutes[i])
                        }
                        getCodeList().then(response => {
                            if(response.code==200) {
                                let arr1 = response.data
                                console.log('过滤出的权限集合',arr1)
                                commit('SET_PERMISSIONS', arr1)
                                commit('SET_ROUTES', children)
                                callback({name: indexroutes[2].children[0].children[0].name,label: indexroutes[2].children[0].children[0].meta.title})
                                resolve()
                            }
                        })

                    })*/
                }
                // resolve(data)
                // callback()
            }).catch(error => {
                reject(error)
            })
        })
    },
    getMenu({commit}){
        return new Promise((resolve, reject) => {
            var list = []
            getMenu({tag: 0}).then(responsemenu => {
                // console.log('用户menu返回',responsemenu)
                list = responsemenu.data
                const indexroutes = []
                const children = []
                // 存放按钮级别的权限，用于区分页面按钮是否显示
                // const permissions = []
                let arr = menuListToRoutes(children, list)
                indexroutes.push(
                    {
                        path: '/article',
                        component: () => import('@/views/app/Article'),
                        hidden: true
                    }, {
                        path: '/pdf',
                        component: () => import('@/views/app/Pdf'),
                        hidden: true
                    }, {
                        path: '/index',
                        component: () => import('@/views/index/layout/Index'),
                        //redirect: arr[0].path,
                        children: arr
                    }, {
                        path: '/dashboard',
                        component: () => import('@/views/index/datav/Index'),
                        hidden: true
                    }, {
                        path: '/up',
                        name: 'SYS-USER-PROJECT',
                        component: () => import('@/views/index/up/Index'),
                        meta: {
                            title: '用户项目'
                        },
                        hidden: true
                    }
                )
                resetRouter()
                commit('RESET_STATE')
                for (let i = 0; i < indexroutes.length; i++) {
                    router.addRoute(indexroutes[i])
                }
                for (let i = 0; i < commonroutes.length; i++) {
                    router.addRoute(commonroutes[i])
                }
                //callback()
                commit('SET_ROUTES', children)
                //console.log(children)
                //{name: indexroutes[2].children[0].children[0].name,label: indexroutes[2].children[0].children[0].meta.title}
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    getCodeList({commit}){
        return new Promise((resolve, reject) => {
            getCodeList().then(response => {
                if(response.code==200) {
                    //console.log(response.data)
                    // menuListToPermissions(permissions,list)
                    let arr1 = response.data
                    //console.log('过滤出的权限集合',arr1)
                    /*router.addRoutes(indexroutes)
                    router.addRoutes(commonroutes)*/
                    commit('SET_PERMISSIONS', arr1)

                    // console.log('用户路由',indexroutes,router)
                    //callback({name: indexroutes[2].children[0].children[0].name,label: indexroutes[2].children[0].children[0].meta.title})
                    resolve()
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
    // user logout
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            logout().then(() => {
                removeToken() // must remove  token  first
                resetRouter()
                commit('RESET_STATE')
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            removeToken() // must remove  token  first
            commit('RESET_STATE')
            resolve()
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
